/**
 * Accept lists shared between an upload surface's `<input accept>` and the
 * drag-and-drop validation that sits alongside it.
 *
 * A drop bypasses the input's `accept` filter entirely, so the two have to agree
 * or a file the picker refuses becomes droppable. Keeping the string in one
 * place is what keeps them honest.
 */

/**
 * Media and transcript files that can be attached to a meeting. Mirrors the
 * backend's multer fileFilter in MeetingRoutes.ts — keep the two in step.
 */
export const MEETING_UPLOAD_ACCEPT = "audio/*,video/*,.vtt,.json";

/** Human-readable form of the above, for helper text under a dropzone. */
export const MEETING_UPLOAD_ACCEPT_LABEL = "Audio, video, VTT or JSON";

/**
 * What the agent chat accepts as a private attachment. Wider than the meeting
 * list because chat also takes documents to read, not just recordings to file.
 */
export const CHAT_UPLOAD_ACCEPT = "audio/*,.vtt,.json,.pdf,.doc,.docx,.txt,.md,.mp4,.webm";
